import {Constants} from "@/constant/Constants";
import {SelectData} from "@/data/SelectData";
import {Outcome} from "@/data/Outcome";
import { GameConfigType, OutcomeType } from '@/types';

export class Config extends SelectData{
    private _outcomes: Outcome[];
    private _selectedOutcome: Outcome;

    constructor(data: GameConfigType) {
        super()
        this._id = data[Constants.ID];
        this._name = data[Constants.NAME];
        this.solidifyOutcomes(data[Constants.OUTCOMES]);
    }

    private solidifyOutcomes(data: Array<OutcomeType>): void {
        this.outcomes = [];
        if(data) {
            for (const outcomeData of data) {
                this.outcomes.push(new Outcome(outcomeData))
            }
            if(this.outcomes.length > 0) {
                this._selectedOutcome = this.outcomes[0];
            }
        }
    }

    get outcomes(): Outcome[] {
        return this._outcomes;
    }
    set outcomes(value: Outcome[]) {
        this._outcomes = value;
    }
    get selectedOutcome(): Outcome {
        return this._selectedOutcome;
    }

    set selectedOutcome(value: Outcome) {
        this._selectedOutcome = value;
    }
}